import React from "react";

const Alert = ({ text }) => {
  return (
    <div
      className="col-12 text-center alert p-2 border-0 alert-secondary"
      role="alert"
    >
      <p className="small lh-base my-1">{text}</p>
    </div>
  );
};

export default Alert;
